import {CardId} from '@raison/types';
import {useParams} from 'react-router';
import {Wish} from '~/library/prelude';

const CardIdParams = Wish.struct({
    id: Wish.string.pipe(Wish.morph(n => parseInt(n) as CardId)),
});

export const useCardIdParam = () => {
    const params = useParams();
    const {id} = Wish.assert(CardIdParams, params);
    return id;
};
